var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isShowComponent
    ? _c("div", { staticClass: "datasheet-button-container" }, [
        _c(
          "a",
          {
            staticClass: "datasheet-button text-muted",
            attrs: { href: _vm.parsedUrl, target: "_blank" }
          },
          [
            _c("i", {
              staticClass: "fa fa-file-pdf-o",
              attrs: { "aria-hidden": "true" }
            }),
            _vm._v(" "),
            _c("span", [
              _vm._v(
                _vm._s(
                  _vm.$translate("EnergyLabel::Template.energyLabelDatasheet")
                )
              )
            ])
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }